module.exports = "build/assets/ogImage.709e542b.png";